export default {
    "accountsAndCards": "Cuentas y tarjetas",
    "accounts": "Cuentas",
    "paidAccount": "Cuenta 1 %",
    "juniorAccount": "Cuenta junior",
    "cards": "Tarjetas",
    "creditCard": "Tarjeta crédito",
    "debitCard": "Tarjeta de débito",
    "investment": "Inversión",
    "weInvest": "Invertimos por ti",
    "youInvest": "Tú inviertes",
    "investmentFund": "Fondos de inversión",
    "indexPortfolio": "Carteras indexadas",
    "indexFunds": "Fondos indexados",
    "plusFunds": "Fondos plus",
    "pensionPlans": "Planes de pensiones",
    "mortgage": "Hipotecas",
    "fixedMortgage": "Hipoteca fija",
    "variableMortgage": "Hipoteca variable",
    "myInvestorMortgage": "Hipotecas MyInvestor",
    "tools": "Herramientas",
    "portfolioSimulator": "Simulador de carteras",
    "fundFinderShort": "Buscador de fondos",
    "fundFinder": "Buscador de fondos de inversión",
    "pensionSimulator": "Simulador de planes de pensiones",
    "pensionPlanFinder": "Buscador de planes de pensiones",
    "newMortgageSimulator": "Simulador Trae tu hipoteca",
    "oldMortgageSimulator": "Simulador Contrata tu hipoteca",
    "julia": "Conoce a Julia",
    "signUp": "Hazte cliente",
    "signIn": "Inicia sesión",
    "becomeCustomer": "Hazte cliente",
    "subscribe": "Suscríbete",
    "insurance": "Seguros",
    "faqs": "Preguntas frecuentes"
};
